import script from "./UserComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserComment.vue?vue&type=script&setup=true&lang=ts"

import "./UserComment.vue?vue&type=style&index=0&id=8be70d82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8be70d82"]])

export default __exports__